export enum ProductType {

    PRODUCT = 0,
    SERVICE = 1,
    CONCEPT = 2

}